class HalSizeGuide {
  constructor(root) {
    this.root = root;
    this.id = root.id;
    this.panel = root.querySelector('.hal-size-guide__panel');
    this.overlay = root.querySelector('.hal-size-guide__overlay');
    this.closeButton = root.querySelector('.hal-size-guide__close');
    this.triggers = document.querySelectorAll(`[aria-controls="${this.id}"]`);
    this.opener = null;
    this.portalHost = null;
    this.isPortaling = false;

    this.onOverlayClick = () => this.close();
    this.onCloseClick = () => this.close();
    this.onTriggerClick = (event) => this.open(event.currentTarget);
    this.onKeydown = (event) => {
      if (event.key === 'Escape' && this.root.classList.contains('is-open')) {
        this.close();
      }
    };

    this.overlay?.addEventListener('click', this.onOverlayClick);
    this.closeButton?.addEventListener('click', this.onCloseClick);
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.onTriggerClick);
    });
    document.addEventListener('keydown', this.onKeydown);

    root.halSizeGuide = this;
  }

  destroy() {
    this.close(false);
    this.restorePortal();
    this.overlay?.removeEventListener('click', this.onOverlayClick);
    this.closeButton?.removeEventListener('click', this.onCloseClick);
    this.triggers.forEach((trigger) => {
      trigger.removeEventListener('click', this.onTriggerClick);
    });
    document.removeEventListener('keydown', this.onKeydown);
    delete this.root.halSizeGuide;
  }

  shouldUsePortal() {
    return !(window.Shopify && Shopify.designMode);
  }

  moveToPortal() {
    if (!this.shouldUsePortal() || this.root.parentElement === document.body) return;

    this.portalHost = document.createComment(`hal-size-guide-portal-${this.id}`);
    this.root.parentElement.insertBefore(this.portalHost, this.root);

    this.isPortaling = true;
    document.body.appendChild(this.root);
    this.isPortaling = false;
  }

  restorePortal() {
    if (!this.portalHost || !this.portalHost.parentNode) return;

    this.isPortaling = true;
    this.portalHost.parentNode.insertBefore(this.root, this.portalHost);
    this.portalHost.remove();
    this.portalHost = null;
    this.isPortaling = false;
  }

  open(trigger) {
    this.opener = trigger || document.activeElement;
    this.moveToPortal();
    this.root.hidden = false;
    this.root.classList.add('is-open');
    document.body.classList.add('overflow-hidden', 'hal-size-guide-open');

    requestAnimationFrame(() => {
      document.body.classList.add('hal-size-guide-open--visible');
    });

    if (typeof trapFocus === 'function' && this.panel) {
      trapFocus(this.panel, this.closeButton);
    } else {
      this.closeButton?.focus();
    }
  }

  close(restoreFocus = true) {
    document.body.classList.remove('hal-size-guide-open--visible');
    this.root.classList.remove('is-open');
    this.root.hidden = true;
    document.body.classList.remove('overflow-hidden', 'hal-size-guide-open');
    this.restorePortal();

    if (!restoreFocus) return;

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.opener);
    } else {
      this.opener?.focus();
    }
  }
}

function initHalSizeGuides() {
  document.querySelectorAll('[data-hal-size-guide]').forEach((root) => {
    if (root.halSizeGuide) return;
    new HalSizeGuide(root);
  });
}

function destroyHalSizeGuides(container = document) {
  container.querySelectorAll('[data-hal-size-guide]').forEach((root) => {
    root.halSizeGuide?.destroy();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHalSizeGuides);
} else {
  initHalSizeGuides();
}

document.addEventListener('product-info:loaded', initHalSizeGuides);

document.addEventListener('shopify:section:load', initHalSizeGuides);
document.addEventListener('shopify:section:unload', (event) => {
  destroyHalSizeGuides(event.target);
});
